import { useTranslation } from "react-i18next";
import { nav, type NavEntry } from "@/content/nav";
import { navEn } from "@/content/nav.en";
import { normalizeLang } from "./index";

/**
 * Returnerar navigationsstrukturen i aktuellt språk.
 * SV → src/content/nav.ts, EN → src/content/nav.en.ts.
 */
export function useLocalizedNav(): NavEntry[] {
  const { i18n } = useTranslation();
  const lang = normalizeLang(i18n.resolvedLanguage ?? i18n.language);
  return lang === "en" ? navEn : nav;
}
